import { ImageSliceState, localImageSelectors } from "../../image/imageSlice";
import GenericSelectors from "./genericSelectors";

export class CommonImageSelectors extends GenericSelectors<ImageSliceState, typeof localImageSelectors> {
    constructor() {
        super(localImageSelectors);
    }
}
